import { type ComponentProps } from 'react';

import clsx from 'clsx';

import styles from '../styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

type Props = ComponentProps<typeof ExtendedLink>;

export function ChipLink({ className, children, ...rest }: Props) {
  return (
    <ExtendedLink className={clsx(styles.chipButton, className)} {...rest}>
      {children}
    </ExtendedLink>
  );
}
